<template>
  <header>
    <div class="goal-outline">
      <router-link to="/">
        <img class="gbe-calculator" src="/GBE-Calculator-Logo-White.png" />
      </router-link>
    </div>
  </header>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component
export default class HeaderBar extends Vue {
  data() {
    return {};
  }
}
</script>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 8rem;
  .goal-outline {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60rem;
    height: 100%;
    background-color: $themeBlack;
    border-left: 7px solid $footballLineColor;
    border-right: 7px solid $footballLineColor;
    border-bottom: 7px solid $footballLineColor;
    font-size: 3rem;
    img {
      width: 20rem;
      vertical-align: middle;
    }
    &::before {
      content: "";
      position: absolute;
      top: -17rem;
      left: 50%;
      z-index: -1;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      width: 40rem;
      height: 30rem;
      border: 7px solid #303030;
      border-radius: 50%;
      @include mix.responsive("sm") {
        top: -18rem;
        width: 35rem;
      }
      @include mix.responsive("xs") {
        width: 32rem;
      }
    }
  }

  .site-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15rem;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
}
</style>
